import { Injectable } from '@angular/core'
import { Observable } from 'rxjs'
import { environment } from '../../environments/environment'
import { ApiService } from './api.service'

export interface NotificationPreference {
  event_type: string
  label: string
  description: string
  inapp_enabled: number
  email_enabled: number
  supports_inapp?: boolean
}

/** Backend event_type keys for admin-only preference rows. */
export const NEW_USER_SIGNUP_EVENT_TYPES = [
  "new_user_signup",
  "user_signup",
  "new_signup",
] as const

export const WEEKLY_NEW_USER_DIGEST_EVENT_TYPES = [
  "weekly_new_user_digest",
  "weekly_user_digest",
  "weekly_new_users",
] as const

export const ADMIN_ONLY_NOTIFICATION_EVENT_TYPES = [
  ...NEW_USER_SIGNUP_EVENT_TYPES,
  ...WEEKLY_NEW_USER_DIGEST_EVENT_TYPES,
] as const

export const ADMIN_NOTIFICATION_PREF_DEFAULTS: NotificationPreference[] = [
  {
    event_type: "new_user_signup",
    label: "New User Signup",
    description: "Alert when a new advertiser account signs up",
    inapp_enabled: 1,
    email_enabled: 1,
    supports_inapp: true,
  },
  {
    event_type: "weekly_new_user_digest",
    label: "Weekly New User Digest",
    description: "Weekly email summary of new advertiser signups",
    inapp_enabled: 0,
    email_enabled: 1,
    supports_inapp: false,
  },
]

export function isWeeklyDigestEventType(eventType: string): boolean {
  return (WEEKLY_NEW_USER_DIGEST_EVENT_TYPES as readonly string[]).includes(eventType)
}

export function isAdminOnlyNotificationEvent(eventType: string): boolean {
  return (ADMIN_ONLY_NOTIFICATION_EVENT_TYPES as readonly string[]).includes(eventType)
}

export interface NotificationPreferencesResponse {
  status: string
  preferences: NotificationPreference[]
}

@Injectable({ providedIn: 'root' })
export class NotificationPreferencesService {
  private apiUrl = `${environment.apiUrl}/notification-preferences`

  constructor(private apiService: ApiService) {}

  getPreferences(): Observable<NotificationPreferencesResponse> {
    return this.apiService
      .authenticatedGet<NotificationPreferencesResponse>(
        this.apiUrl)
  }

  updatePreferences(
    preferences: NotificationPreference[]
  ): Observable<any> {
    return this.apiService.authenticatedPut(
      this.apiUrl, { preferences })
  }
}
